import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, takeUntil } from 'rxjs';
import { Order, OrderShuttleVM } from '../../../../../models/orderModel';
import { MyConfigOrganization } from '../../../../../models/myConfig';
import { OrderShuttleService } from '../../../../../services/ordershuttle.service';
import { OrderShuttleBusService } from '../../../../../services/ordershuttlebus.service';
import { EventQueueService } from '../../../../../services/eventqueue.service';
import { AuthService } from '../../../../../services/auth.service';
import { BackOfficeService } from '../../../../../services/backoffice.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import moment from 'moment';

@Component({
  selector: 'app-back-office24-ordershuttlebus-bookings',
  templateUrl: './back-office24-ordershuttlebus-bookings.component.html',
  styleUrl: './back-office24-ordershuttlebus-bookings.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class BackOffice24OrderShuttlebusBookingsComponent implements OnInit, OnDestroy {
  @Input() organization: MyConfigOrganization;
  @Input() orderShuttles: OrderShuttleVM[];
  orderShuttlesPickupArrival: OrderShuttleVM[] = [];
  orderShuttlesPickupDeparture: OrderShuttleVM[] = [];
  orderShuttlesOtherArrival: OrderShuttleVM[] = [];
  orderShuttlesOtherDeparture: OrderShuttleVM[] = [];

  isLoading = false;

  showFlightDetailsPickupArrival = false;
  showFlightDetailsPickupDeparture = false;
  showFlightDetailsOtherArrival = false;
  showFlightDetailsOtherDeparture = false;

  showCustDetailsPickupArrival = false;
  showCustDetailsPickupDeparture = false;
  showCustDetailsOtherArrival = false;
  showCustDetailsOtherDeparture = false;

  intervalId: any;
  componentDestroyed$: Subject<boolean> = new Subject();
  order: Order;

  problemTypes = {
    "DepartureFlightCanceled": "Departure Flight Cancelled",
    "ArrivalFlightCanceled": "Arrival Flight Cancelled"
  }
  problemOrders: Map<string, string> = new Map<string, string>();

  constructor(
    public snackBar: MatSnackBar,
    public orderShuttleService: OrderShuttleService,
    public orderShuttleBusService: OrderShuttleBusService,
    public dialog: MatDialog,
    public eventQueue: EventQueueService,
    private authService: AuthService,
    public router: Router,
    private backOfficeService: BackOfficeService
  ) { }

  ngOnInit(): void {
    this.refreshOrderShuttles();
    this.intervalId = setInterval(() => this.refreshOrderShuttles(), 60000);
  }

  refreshOrderShuttles() {
    if (this.organization.config.handleFlights) {
      this.testProblemOrders(this.organization.organizationId || 'a848ccd3-fd8d-4035-925e-571ebb4e93e8');
    }

    if (this.authService.loggedIn()) {
      this.getOrderShuttlesOther();
    }
  }

  testProblemOrders(organizationId: string) {
    this.isLoading = true;
    this.backOfficeService.getProblemOrders(organizationId).pipe(takeUntil(this.componentDestroyed$))
      .subscribe({
        next: (ProblemOrders) => {
          ProblemOrders.orders.forEach(order => {
            this.problemOrders.set(order.orderId, order.problem);
          });

          this.orderShuttles.forEach(orderShuttle => {
            orderShuttle.problemFlight = {
              arrival: false,
              departure: false
            };
            if (this.problemOrders.has(orderShuttle.orderId)) {
              if (this.problemOrders.get(orderShuttle.orderId) === 'ArrivalFlightCanceled') {
                orderShuttle.problemFlight.arrival = true;
              } else if (this.problemOrders.get(orderShuttle.orderId) === 'DepartureFlightCanceled') {
                orderShuttle.problemFlight.departure = true;
              }
            }
          })
          // this.problemFlightsDataSource.data = problemsData;
          // this.problemFlightsDataSource.sort = this.sort;
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Error fetching problem orders:', error);
        }
      });
  }

  setOrderShuttlesPickup(orderShuttles: OrderShuttleVM[]) {
    let pickups = orderShuttles.filter(s => s.status === 'ReadyForPickup');
    // console.log('getOrderShuttlesPickup start', orderShuttles);
    pickups.forEach(orderShuttle => {
      // console.log('getOrderShuttlesPickup getNewTime Start', orderShuttle);
      orderShuttle.shuttleDateNew = this.getNewTime(orderShuttle);
      // console.log('getOrderShuttlesPickup getNewTime End', orderShuttle);
      // console.log('getOrderShuttlesPickup getIsReadyForPickup', orderShuttle);
      orderShuttle.isReadyForPickup = this.getIsReadyForPickup(orderShuttle)
    });
    // console.log('getOrderShuttlesPickup complete', orderShuttles);

    this.orderShuttlesPickupArrival = [];
    this.orderShuttlesPickupDeparture = [];

    pickups.sort(
      function (a, b) {
        return new Date(a.shuttleDateNew).valueOf() - new Date(b.shuttleDateNew).valueOf();
      }
    ).forEach(orderShuttle => {

      if (orderShuttle.productType == 'ShuttleDeparture') {
        if (moment(orderShuttle.shuttleDate) == moment(orderShuttle.shuttleDateNew)) {
          orderShuttle.shuttleDateNew = null;
        }
        this.orderShuttlesPickupDeparture.push(orderShuttle);
      }

      if (orderShuttle.productType == 'ShuttleArrival') {
        orderShuttle.shuttleDateNew = this.getNewTime(orderShuttle);
        this.orderShuttlesPickupArrival.push(orderShuttle);
      }
    });

    this.orderShuttlesPickupDeparture.sort(
      function (a, b) {
        return new Date(a.shuttleUpdated).valueOf() - new Date(b.shuttleUpdated).valueOf();
      }
    );
    // console.log('this.orderShuttlesPickupArrival', this.orderShuttlesPickupArrival);
    // console.log('this.orderShuttlesPickupDeparture', this.orderShuttlesPickupDeparture);
  }

  getIsReadyForPickup(orderShuttle: OrderShuttleVM): boolean {
    // console.log('getIsReadyForPickup Start', orderShuttle);
    if (orderShuttle.arrivalVM) { //Flight exists
      if (orderShuttle.baggage > 0) { //Has Baggage
        if (orderShuttle.arrivalVM.firstBag != null) { //Firstbag set
          var firstBag = moment(orderShuttle.arrivalVM.firstBag);
          if (firstBag.isSameOrBefore(moment())) { //Firstbag is before now
            //  console.log('getIsReadyForPickup End: true');
            return true
          }
          else { //Firstbag is after now
            //  console.log('getIsReadyForPickup End: false');
            return false;
          }
        }
        else { //Firstbag not set yet
          //  console.log('getIsReadyForPickup End: false');
          return false;
        }
      }
      else { //No Baggage
        var pickupTime = moment(orderShuttle.shuttleDateNew).subtract(30, 'minutes');
        //  console.log('getIsReadyForPickup End: ' + pickupTime.isSameOrBefore(moment()));
        return pickupTime.isSameOrBefore(moment());
      }
    }
    else { //Flight does not exis
      var pickupTime = moment(orderShuttle.shuttleDateNew).subtract(30, 'minutes');
      //  console.log('getIsReadyForPickup End: ' + pickupTime.isSameOrBefore(moment()));
      return pickupTime.isSameOrBefore(moment());
    }
  }

  getOrderShuttlesOther() {

    let orderShuttlesOtherNewArrival: OrderShuttleVM[] = [];
    let orderShuttlesOtherNewDeparture: OrderShuttleVM[] = [];

    this.setOrderShuttlesPickup(this.orderShuttles);
    // console.log('getOrderShuttlesOther', orderShuttles);
    this.orderShuttles.forEach(orderShuttle => {

      if (orderShuttle.status == 'Paid') {
        // console.log('Paid', orderShuttle);
        if (orderShuttle.productType == 'ShuttleDeparture') {
          // console.log('ShuttleDeparture', orderShuttle);
          orderShuttlesOtherNewDeparture.push(orderShuttle);
        }

        if (orderShuttle.productType == 'ShuttleArrival') {
          // console.log('ShuttleArrival', orderShuttle);
          orderShuttle.shuttleDateNew = this.getOtherCustomerTime(orderShuttle);
          // orderShuttle.isReadyForPickup = this.getIsReadyForPickup(orderShuttle)
          orderShuttlesOtherNewArrival.push(orderShuttle);
        }
      }
    });
    this.orderShuttlesOtherArrival = [];
    this.orderShuttlesOtherDeparture = [];

    orderShuttlesOtherNewDeparture.sort(
      function (a, b) {
        return new Date(a.shuttleDate).valueOf() - new Date(b.shuttleDate).valueOf();
      }
    ).forEach(orderShuttle => {
      this.orderShuttlesOtherDeparture.push(orderShuttle);
    });

    orderShuttlesOtherNewArrival.sort(
      function (a, b) {
        return new Date(a.shuttleDateNew).valueOf() - new Date(b.shuttleDateNew).valueOf();
      }
    ).forEach(orderShuttle => {
      if (moment(orderShuttle.shuttleDate) == moment(orderShuttle.shuttleDateNew)) {
        orderShuttle.shuttleDateNew = null;
      }
      this.orderShuttlesOtherArrival.push(orderShuttle);
    });
  }


  changeShowCustDetailsPickupArrival($event) {
    this.showCustDetailsPickupArrival = $event.checked;
  }

  changeShowCustDetailsPickupDeparture($event) {
    this.showCustDetailsPickupDeparture = $event.checked;
  }

  changeShowCustDetailsOtherArrival($event) {
    this.showCustDetailsOtherArrival = $event.checked;
  }

  changeShowCustDetailsOtherDeparture($event) {
    this.showCustDetailsOtherDeparture = $event.checked;
  }

  changeShowFlightDetailsPickupArrival($event) {
    this.showFlightDetailsPickupArrival = $event.checked;
  }

  changeShowFlightDetailsPickupDeparture($event) {
    this.showFlightDetailsPickupDeparture = $event.checked;
  }

  changeShowFlightDetailsOtherArrival($event) {
    this.showFlightDetailsOtherArrival = $event.checked;
  }

  changeShowFlightDetailsOtherDeparture($event) {
    this.showFlightDetailsOtherDeparture = $event.checked;
  }


  getNewTime(orderShuttle: OrderShuttleVM): Date {
    // console.log('getNewTime Start', orderShuttle);
    var resultingDate: Date = null;
    if (orderShuttle.arrivalId) {

      let addMinutes = 25;
      let addMinutesBaggageArrived = 15;
      if (orderShuttle.baggage > 0) {
        addMinutes = 45;
      }
      // console.log('orderShuttle.arrivalVM.status', orderShuttle.arrivalVM.status);
      // console.log('getNewTime', orderShuttle);

      if (orderShuttle.arrivalVM.status == 'New' ||
        orderShuttle.arrivalVM.status == 'Scheduled' ||
        orderShuttle.arrivalVM.status == 'Active' ||
        orderShuttle.arrivalVM.status == 'Deleted' ||
        orderShuttle.arrivalVM.status == 'Cancelled'
      ) {
        // console.log('NewScheduledActiveDeletedCanceled', orderShuttle);
        if (orderShuttle.arrivalVM.actualArrival) {
          //  console.log('actualArrival', orderShuttle);
          resultingDate = moment(orderShuttle.arrivalVM.actualArrival).add(addMinutes, 'm').toDate();
        } else if (orderShuttle.arrivalVM.estimatedArrival) {
          //  console.log('estimatedArrival', orderShuttle);
          resultingDate = moment(orderShuttle.arrivalVM.estimatedArrival).add(addMinutes, 'm').toDate();
        } else if (orderShuttle.arrivalVM.scheduledArrival) {
          //  console.log('scheduledArrival', orderShuttle);
          resultingDate = moment(orderShuttle.arrivalVM.scheduledArrival).add(addMinutes, 'm').toDate();
        }
      }

      if (orderShuttle.arrivalVM.status == 'Landed' ||
        orderShuttle.arrivalVM.status == 'FirstBaggage' ||
        orderShuttle.arrivalVM.status == 'LastBaggage'
      ) {
        // console.log('Landed', orderShuttle);
        if (orderShuttle.arrivalVM.firstBag) {
          // console.log('firstBag', orderShuttle);
          resultingDate = moment(orderShuttle.arrivalVM.firstBag).add(addMinutesBaggageArrived, 'm').toDate();
        } else if (orderShuttle.arrivalVM.actualArrival) {
          // console.log('actualArrival', orderShuttle);
          resultingDate = moment(orderShuttle.arrivalVM.actualArrival).add(addMinutes, 'm').toDate();
        }
      }

      return resultingDate;
    }
    return new Date(orderShuttle.shuttleDate);
  }

  getOtherCustomerTime(orderShuttle: OrderShuttleVM): Date {
    // console.log('getNewTime Start');
    var resultingDate: Date = null;
    if (orderShuttle.arrivalId) {

      let addMinutes = 25;
      let addMinutesBaggageArrived = 15;
      if (orderShuttle.baggage > 0) {
        addMinutes = 45;
      }
      // console.log('orderShuttle.arrivalVM.status', orderShuttle.arrivalVM.status);
      // console.log('getNewTime', orderShuttle);

      if (orderShuttle.arrivalVM.status == 'New' ||
        orderShuttle.arrivalVM.status == 'Scheduled' ||
        orderShuttle.arrivalVM.status == 'Active' ||
        orderShuttle.arrivalVM.status == 'Deleted' ||
        orderShuttle.arrivalVM.status == 'Cancelled'
      ) {
        // console.log('NewScheduledActiveDeletedCanceled');
        if (orderShuttle.arrivalVM.actualArrival) {
          // console.log('actualArrival');
          resultingDate = moment(orderShuttle.arrivalVM.actualArrival).add(addMinutes, 'm').toDate();
        } else if (orderShuttle.arrivalVM.estimatedArrival) {
          // console.log('estimatedArrival');
          resultingDate = moment(orderShuttle.arrivalVM.estimatedArrival).add(addMinutes, 'm').toDate();
        } else if (orderShuttle.arrivalVM.scheduledArrival) {
          // console.log('scheduledArrival');
          resultingDate = moment(orderShuttle.arrivalVM.scheduledArrival).add(addMinutes, 'm').toDate();
        }
      }

      if (orderShuttle.arrivalVM.status == 'Landed' ||
        orderShuttle.arrivalVM.status == 'FirstBaggage' ||
        orderShuttle.arrivalVM.status == 'LastBaggage'
      ) {
        //  console.log('Landed');
        if (orderShuttle.arrivalVM.firstBag) {
          //  console.log('firstBag');
          resultingDate = moment(orderShuttle.arrivalVM.firstBag).add(addMinutesBaggageArrived, 'm').toDate();
        } else if (orderShuttle.arrivalVM.actualArrival) {
          //  console.log('actualArrival');
          resultingDate = moment(orderShuttle.arrivalVM.actualArrival).add(addMinutes, 'm').toDate();
        }
      }
      return resultingDate;
    }
    return new Date(orderShuttle.shuttleDate);
  }

  getNewTimeColor(orderShuttle: OrderShuttleVM): string {

    if (orderShuttle.shuttleDateNew) {
      if (moment(orderShuttle.shuttleDateNew) > moment(orderShuttle.shuttleDate)) {
        return 'color: red;';
      }
    }

    return '';
  }

  removeLastPart(text) {
    const lastColonIndex = text.lastIndexOf(":");
    return lastColonIndex !== -1 ? text.slice(0, lastColonIndex) : text;
  }

  displayRouteName(orderShuttle: OrderShuttleVM): string {
    let routeName = orderShuttle.routeName;
    if (routeName == 'Från Arlanda till Arlanda XPO Apartments') {
      return 'XPO';
    }
    if (routeName == 'Från Arlanda XPO Apartments till Arlanda') {
      return 'XPO';
    }
    if (routeName == 'Från Arlanda till Scandic') {
      return 'Scandic';
    }
    if (routeName == 'Från Scandic till Arlanda') {
      return 'Scandic';
    }
    if (routeName == 'Från Hotel till Arlanda') {
      const hotelMap: Record<string, string> = {
        '417596F5-8FE5-4FA7-84DC-0AF0ACE72CF1': 'Scandic',
        '5BF79F25-27BF-4B5B-AF83-B4A0233DAB70': 'ApartDirect',
        '39218780-069A-4C6B-9925-22365A075C15': 'Quality',
        'D6B9D8C6-8FB5-41A5-AC2E-B3FC007A8251': 'Aiden'
      };
      return hotelMap[orderShuttle.organizationId.toUpperCase()] || '';
    }

    return routeName;
  }

  displayHotelName(orgId: string): string {
    if (orgId == '942ce067-7848-4441-b746-8f6eed7395bb') {
      return 'Quality';
    }
    return '';
  }

  goToOrder(order: Order): void {
    this.order = order;
    const url = this.router.serializeUrl(this.router.createUrlTree([`/admin/back-office24-order/${order.orderId}`]));
    window.open(url, '_blank');
  }

  isHotel(orderShuttle: OrderShuttleVM): boolean {
    if (!orderShuttle || !orderShuttle.organizationId) return false;

    const hotelOrgIds = [
      '417596f5-8fe5-4fa7-84dc-0af0ace72cf1', // Scandic
      '5bf79f25-27bf-4b5b-af83-b4a0233dab70', // ApartDirect
      '39218780-069a-4c6b-9925-22365a075c15', // Quality
      '942ce067-7848-4441-b746-8f6eed7395bb', // Quality XPO
      'd6b9d8c6-8fb5-41a5-ac2e-b3fc007a8251', // Aiden
      '55d7084d-3cf0-4ccc-9448-f924afcdf3bc'  // Aiden Short Term
    ];

    return hotelOrgIds.includes(orderShuttle.organizationId.toLowerCase());
  }

  isRedKeyStatus(status: string): boolean {
    return [
      'FromCustomerManualToDo',
      'FromCustomerAutomatedNoKey',
      'ToCustomerManualToDo',
      'ToCustomerAutomatedNoKey'
    ].includes(status);
  }

  isGreenKeyStatus(status: string): boolean {
    return [
      'FromCustomerManualDone',
      'FromCustomerAutomatedKeyIn',
      // 'ToCustomerManualDone',
      // 'ToCustomerAutomatedKeyIn'
    ].includes(status);
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
    clearInterval(this.intervalId);
  }
}
